import { faWeightScale } from "@fortawesome/free-solid-svg-icons";
import { Chart, ChartData, CustomTooltipProps, TitleStyle, TooltipContainer, TooltipText } from "./Chart";
import { useMemo } from "react";
import { DateTime } from "luxon";
import { Guard } from "../utils";
import _ from "lodash";

const CustomTooltip = ({ active, payload }: CustomTooltipProps): JSX.Element => {
  if (active && payload && payload.length) {
    const fat = payload[0].value as number;
    return (
      <TooltipContainer>
        <TooltipText>{`Body Fat: ${fat.toPrecision(2)} %`}</TooltipText>
      </TooltipContainer>
    );
  } else {
    return <></>;
  }
};

type BodyFatChartData = ChartData & {
  bodyFatPercentage: number;
};

const isBodyFatData: Guard<BodyFatChartData> = (data: unknown): data is BodyFatChartData => {
  return (data as BodyFatChartData).bodyFatPercentage !== undefined;
};

export function getBodyFatPredictionData({ data, showTitle }: { data: BodyFatChartData[]; showTitle: TitleStyle | undefined }) {
  if (data != null && data.length > 0) {
    const showYear = data[data.length - 1].date.year === DateTime.local().year;
    const predictedDate = _.last(data)!.date.toFormat(`d MMM${showYear ? '' : ' yyyy'}`);
    const titlePrefix = TitleStyle.Text === showTitle ? 'You can reach' : `YOUR BODY FAT LOSS`;
    const titlePrediction = `${_.last(data)!.bodyFatPercentage}% body fat by`;
    const titlePredictionDate = predictedDate;

    return {
      titlePrefix,
      titlePrediction,
      titlePredictionDate,
    }
  }
  return null;
}

type BodyFatChartProps = {
  data: BodyFatChartData[];
  showTitle?: TitleStyle;
  showOnlyTitle?: boolean;
  showBigHeader?: boolean;
}

const BodyFatChart = (props: BodyFatChartProps) => {
  const { data, showTitle, showOnlyTitle, showBigHeader } = props;
  const predictionData = useMemo(() => {
    return getBodyFatPredictionData({ data, showTitle });
  }, [data, showTitle]);

  if (predictionData) {
    const { titlePrefix, titlePrediction, titlePredictionDate } = predictionData;

    return <Chart
      data={data}
      dataKey="bodyFatPercentage"
      showTitle={showTitle}
      icon={faWeightScale}
      CustomTooltip={CustomTooltip}
      titlePrefix={titlePrefix}
      titlePrediction={titlePrediction}
      titlePredictionDate={titlePredictionDate}
      finalMarker={`${titlePrediction} ${titlePredictionDate}`}
      caret={'▼'}
      markerLocation="bottom"
      yAxisLabel="Body Fat (%)"
      showOnlyTitle={showOnlyTitle}
      showBigHeader={showBigHeader}
    />;
  } else {
    return <></>;
  }
};

export {
  BodyFatChart,
  isBodyFatData,
};
export type { BodyFatChartData };
